
module fdm.pilotPerformance {

    class KpiRatingController {

        public showPercent: Boolean;
        public value: dg.domain.IDomainObject;
        public displayName: string;
        
        //gauge metrics
        public size: number;
        public width: number;
        public height: number;
        public radius: number;
        public circumference: number;
        public gaugeValue: number;
        public textX: number = 40;

        public constructor(
            protected $scope: ng.IScope,
            protected $element: JQuery,
        ) {
        }


        $onInit() {
            this.calcGaugeSize();
        }

        $onChanges(changes) {
            if(this.size) {
                this.calcGaugeSize();
            }
            const valueObject = (this.value as any);
            if (valueObject && valueObject.currentValue) {
                //console.log(this.value)
                this.showPercent = this.value.dgMeta.properties.currentValue.dataType == dg.restfulApi.DG_DATA_TYPES.Percent;
                const percentage = (100 - valueObject.currentValue.value) / 100;
                this.gaugeValue = Math.round(this.circumference / 2 * percentage)

                const textElement: any = this.$element.find('.current-value-text');
                // var bbox = textElement.getBBox && textElement.getBBox();
                const textWidth = (valueObject.currentValue.value.toString().length + 1) * 11;                
                this.textX = this.width / 2 - textWidth / 2;
            }
        }

        calcGaugeSize(){
            const size = this.size || 120;
            this.width = size * 1.2;
            this.height = size * 1.2 / 2;
            this.radius = size / 2;
            this.circumference = 2 * Math.PI * this.radius;
            
        }
    }

    angular.module('fdm.pilotPerformance').component('kpiRating', {
        bindings: {
            value: '<',
            displayName: '@',
            size: '<'
        },
        controller: KpiRatingController,
        templateUrl: '/app/src/pilot-performance/kpi-rating.html'
    });
}